/**
 * The pages that carry the top bar's global filter.
 *
 * The control renders on these routes only, so these are also the only pages
 * whose content may read the filter. A page that narrowed its figures from a
 * stored selection with no control to see or clear would leave someone
 * looking at a filtered number and no way to tell.
 */
const SUPPORTED_ROUTES = [
  '/risks',
  '/assets',
  '/vulnerabilities',
  '/agent-security',
  '/data-security',
  '/threat-mapping',
];

/** Pages matched exactly, because their siblings cannot honour the filter. */
const SUPPORTED_PAGES = [
  '/findings/list',
  '/findings/exemptions',
  '/alerts',
  // Access grants, the Entitlements landing tab.
  '/entitlements',
  '/entitlements/access-grants',
];

/**
 * One framework or lens. The lists beside them read tenant-wide posture, and
 * Well-Architected workloads are each pinned to their own asset group.
 */
const FRAMEWORK_DETAIL =
  /^\/(compliance\/[^/]+|well-architected\/lenses\/[^/]+|compliance-and-well-architected\/(?!workloads(\/|$))[^/]+)\/?$/;

/**
 * A saved report opened to read. The editor at the same path is left out: a
 * selection made elsewhere would narrow its preview with nothing on screen to
 * say so.
 */
const REPORT_VIEWER = /^\/settings\/custom-reports\/[^/]+\/editor\/?$/;

export const isGlobalFilterRoute = (pathname: string, search = ''): boolean => {
  // Home dashboard.
  if (pathname === '/') {
    return true;
  }
  if (SUPPORTED_PAGES.includes(pathname) || FRAMEWORK_DETAIL.test(pathname)) {
    return true;
  }
  if (REPORT_VIEWER.test(pathname)) {
    return new URLSearchParams(search).get('mode') === 'readOnly';
  }
  return SUPPORTED_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`),
  );
};
